import { useState } from 'react';
import type { DateRange } from 'react-day-picker';

type RangePresentation = {
  inputValue: string;
  pickerValue: DateRange;
};

export const useDateRangeState = (
  initialValue: DateRange,
  formatDateRange: (range: DateRange) => string,
) => {
  const [tempRange, setTempRange] = useState<DateRange>(initialValue);
  const [isTyping, setIsTyping] = useState(false);
  const [range, setRange] = useState<RangePresentation>({
    inputValue: formatDateRange(initialValue),
    pickerValue: initialValue,
  });

  return {
    tempRange,
    setTempRange,
    isTyping,
    setIsTyping,
    range,
    setRange,
  };
};
